import axios from 'axios'
import {getAdminToken} from '../../auth/_requests'

const API_URL = process.env.REACT_APP_API_URL

const adminApi = axios.create({
  withCredentials: true,
  validateStatus: (status) => (status >= 200 && status < 300) || status === 304
})

adminApi.interceptors.request.use((config) => {
  const token = getAdminToken()
  if (token && config.headers) {
    config.headers.Authorization = `Bearer ${token}`
  }
  return config
})

export interface SubProfile {
  _id: string
  name: string
  facebook_id: string
  is_online: boolean
  posts_per_day: number
}

export interface SubProfileAccountStats {
  account_id: string
  name: string
  email: string
  company_name: string
  is_locked: boolean
  active_sub_profiles: number
  profiles: SubProfile[]
}

export interface SubProfileSummary {
  total_sub_profiles: number
  active_sub_profiles: number
  inactive_sub_profiles: number
  accounts_with_active: number
  total_parent_profiles: number
}

export interface SubProfileStatsResponse {
  success: boolean
  summary: SubProfileSummary
  accounts: SubProfileAccountStats[]
}

export function getSubprofileStats(): Promise<{data: SubProfileStatsResponse}> {
  return adminApi.get(`${API_URL}/admin/subprofiles/stats`)
}
